import { useSuspenseQuery } from "@tanstack/react-query";
import { useEffect } from "react";

import { OrganizationService } from "services/organization";
import { ReactQueryKeysGlobal } from "services/queryKeys";

import {
  Organization,
  OrganizationEdition,
} from "pages/organization/organization.types";

import { StatusMessageType } from "components/StatusMessageQueue/StatusMessageQueueProvider";
import useStatusMessageQueue from "components/StatusMessageQueue/hooks/useStatusMessageQueue";

const LiteOrganization: Organization = {
  organizationId: "firebolt",
  organizationName: "firebolt",
  organizationOwner: "firebolt",
  isPaymentRegistered: true,
  billingProfileName: "firebolt-core-billing-profile",
  nextPaymentMethodName: "",
  created: "",
  lastAltered: "",
  lastAlteredBy: "",
  networkPolicyName: "",
  edition: OrganizationEdition.standard,
  paymentMethodName: "firebolt-core-payment-method",
  creditsRemaining: "0",
  sso: {
    signOnUrl: "firebolt-core-sso-url",
    issuer: "firebolt-core-sso-issuer",
    provider: "firebolt-core-sso-provider",
    label: "firebolt-core-sso-label",
    fieldMapping: {
      first_name: "first_name",
      last_name: "last_name",
    },
    certificate: "firebolt-core-sso-certificate",
  },
};

export const fetchOrganization = async () => {
  return process.env.REACT_APP_LITE
    ? LiteOrganization
    : await OrganizationService.getOrganization();
};

export const useOrganization = () => {
  const { putStatusMessage } = useStatusMessageQueue();
  const { data, isLoading, isError, error } = useSuspenseQuery({
    queryKey: [ReactQueryKeysGlobal.organization],
    queryFn: fetchOrganization,
  });

  useEffect(() => {
    if (isError) {
      putStatusMessage({
        message: error?.message,
        type: StatusMessageType.Error,
      });
    }
  }, [isError, error, putStatusMessage]);

  return { data, isLoading };
};
